export class ZendeskMetadata {
	constructor(
		public tags: Array<string>,
		public currentPageUrl: string
	) {}

}
